import { message, setCreatedTreeKey, setIsFetching } from "../../../actions";
import Configuration from "../../../config.js";
import ReactGA from "react-ga";

/**
 * Konstanten
 */
export const SET_BLOCK_QUESTIONS_ANSWERS = "SET_BLOCK_QUESTIONS_ANSWERS";
export const SET_QUESTION_ANSWERS = "SET_QUESTION_ANSWERS";

/**
 * Setter
 */
export function setBlockQuestionAnswers( questionnaire_id, block_id, question_id, json )
{
	return {
		type: SET_BLOCK_QUESTIONS_ANSWERS,
		questionnaire_id,
		block_id,
		question_id,
		json
	};
}

export function setQuestionAnswers( questionnaire_id, question_id, json )
{
	return {
		type: SET_QUESTION_ANSWERS,
		questionnaire_id,
		question_id,
		json
	};
}

/**
 * Zeigt alle Fragebögen in der Übersicht an
 *
 * @param {number} a_questionnaire_id   Fragebogen Id
 * @param {number} a_block_id           Block Id
 * @param {number} a_question_id        Frage Id
 * @param {String} a_created_key        Angelegter Key
 */
export function getQuestionAnswers( a_questionnaire_id, a_block_id, a_question_id, a_created_key )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Antwort",
				action: "Antworten laden"
			} );
		}
		
		const jwt = getState().jwt;
		const headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${a_questionnaire_id}/questions/${a_question_id}/answers?${+new Date()}`,
			{
				credentials: "include",
				method: "GET",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									// Antworten sortieren
									const answers = Object.keys( json ).sort( ( answer1, answer2 ) => json[answer1].sort_id - json[answer2].sort_id )
										.map( a_key => json[a_key] );
									dispatch( setQuestionAnswers( a_questionnaire_id, a_question_id, answers ) );
									dispatch( setBlockQuestionAnswers( a_questionnaire_id, a_block_id, a_question_id, json ) );
									
									// Wenn zuvor eine Antwort angelegt wurde
									if ( a_created_key )
									{
										dispatch( setCreatedTreeKey( a_created_key ) );
									}
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getBlockQuestions(...)

/**
 * Api-Anfrage: Neuen Antwort erstellen
 *
 * @param {Object} a_formData           Formulardaten
 * @param {number} a_questionnaire_id   Fragebogen Id
 * @param {number} a_block_id           Block Id
 * @param {number} a_question_id        Frage Id
 */
export function createAnswers( a_formData, a_questionnaire_id, a_block_id, a_question_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Antwort",
				action: "Antwort anlegen"
			} );
		}
		
		const jwt = getState().jwt;
		const headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/admin/answers`,
			{
				credentials: "include",
				method: "POST",
				body: JSON.stringify( a_formData ),
				headers
			}
		)
			.then(
				response =>
				{
					// Antwort angelegt
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									// Da es nach erfolgreicher Erstellung neue Antworten gibt, wird erneut die Api aufgerufen um die Antworten in den Store zu laden.
									dispatch( getQuestionAnswers( a_questionnaire_id, a_block_id, a_question_id, `menuTree-answers-${json}` ) );
								}
							);
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( "Antwort erfolgreich angelegt.", "info", 5000 ) );
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function createAnswers(...)

/**
 * Api-Anfrage: Antwort bearbeiten
 *
 * @param {Object} a_formData           Formulardaten
 * @param {number} a_answer_id   Umfrageantwort Id
 * @param {number} a_question_id        Frage Id
 * @param {number} a_block_id           Block Id
 * @param {number} a_questionnaire_id   Fragebogen Id
 * @param {string} a_params             Parameter
 */
export function patchAnswers( a_formData, a_answer_id, a_question_id, a_block_id, a_questionnaire_id, a_params )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Answers",
				action: "Antwort bearbeiten"
			} );
		}
		
		const params = a_params ? "?" + a_params : "";
		
		const jwt = getState().jwt;
		const headers = jwt !== null ? { "JWT": jwt } : {};
		headers["content-type"] = "application/json";
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${a_questionnaire_id}/answers/${a_answer_id}${params}`,
			{
				credentials: "include",
				method: "PATCH",
				headers,
				body: JSON.stringify( a_formData )
			}
		)
			.then(
				response =>
				{
					// Antwort aktualisiert
					if ( response.ok )
					{
						// Nach erfolgreicher Änderung die Antworten erneut in den Store zu laden.
						dispatch( getQuestionAnswers( a_questionnaire_id, a_block_id, a_question_id ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						switch ( a_params )
						{
							case "sort":
								dispatch( message( "Die Antwort wurde verschoben.", "info", 5000 ) );
								break;
							case "move":
								dispatch( getQuestionAnswers( a_questionnaire_id, a_formData.block_id, a_formData.question_id ) );
								dispatch( message( "Die Antwort wurde verschoben.", "info", 5000 ) );
								break;
							default:
								dispatch( message( "Die Antwort wurde erfolgreich geändert.", "info", 5000 ) );
						}
						
					}
					// Eingabefehler oder Serverfehler
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function patchAnswers(...)

/**
 * Api-Anfrage: Antwort löschen
 *
 * @param {number} a_id                 Antwort Id
 * @param {number} a_questionnaire_id   Fragebogen Id
 * @param {number} a_block_id           Block Id
 * @param {number} a_question_id        Frage Id
 */
export function deleteAnswers( a_id, a_questionnaire_id, a_block_id, a_question_id )
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		// Google Analytics
		if ( localStorage.getItem( "ga" ) )
		{
			ReactGA.event( {
				category: "Antwort",
				action: "Antwort löschen"
			} );
		}
		
		const jwt = getState().jwt;
		const headers = jwt !== null ? { "JWT": jwt } : {};
		
		return fetch(
			`${Configuration.apiUrl}/admin/questionnaires/${a_questionnaire_id}/answers/${a_id}`,
			{
				credentials: "include",
				method: "DELETE",
				headers
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						// Da es nach dem Löschen weniger Antworten gibt, wird erneut die Api aufgerufen um die Antworten in den Store zu laden.
						dispatch( getQuestionAnswers( a_questionnaire_id, a_block_id, a_question_id ) );
						
						// Der Nutzer soll ein Alert erhalten, dass die Anfrage erfolgreich war.
						dispatch( message( "Antwort erfolgreich gelöscht.", "info", 5000 ) );
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function deleteAnswers(...)